import { NavLink } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

const values = [
  {
    title: 'Juridisk korrekt',
    desc: 'Lejeloven er kompleks. Vi bygger compliance ind i produktet fra dag ét — § 93-frister, NPI-regulering og påkravsregler er testet, ikke gættet.',
  },
  {
    title: 'Ingen overraskelser',
    desc: 'Klare priser. Ingen binding. Ingen skjulte gebyrer. Hvis du vil skifte, hjælper vi dig eksportere dine data.',
  },
  {
    title: 'Bygget til Danmark',
    desc: 'Betalingsservice, MitID, BBR, e-conomic — vi integrerer med det danske finansielle og offentlige infrastruktur du allerede bruger.',
  },
]

export default function AboutPage() {
  return (
    <>
      {/* Hero */}
      <section className="bg-navy-950 text-white py-20 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-5">Om Boligflow</h1>
          <p className="text-navy-200 text-lg leading-relaxed">
            Vi bygger den ejendomsadministrationsplatform vi selv ønskede fandtes.
            Enkel, lovmedholdelig og dansk.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 px-6 bg-cream">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-navy-950 mb-8">Historien</h2>
          <div className="space-y-5 text-navy-700 leading-relaxed">
            <p>
              Boligflow startede som en frustration. Som udlejer brugte jeg Word-skabeloner til
              lejekontrakter, Excel til at holde styr på betalinger og hukommelsen til
              at huske varslingsskrivelser. Det var tidskrævende, fejlbehæftet og juridisk usikkert.
            </p>
            <p>
              De eksisterende systemer på markedet er enten for simple — og springer lovpligtige
              trin over — eller for tunge og dyre til den private udlejer med 5-50 lejemål.
              Proper, Eindom og Rentdesk gør dele af det godt. Ingen gør det hele rigtigt.
            </p>
            <p>
              Boligflow bygger vi fra bunden med lejelovens krav som fundament. Ikke som eftertanke.
              Det betyder at § 93-frister beregnes korrekt, NPI-regulering sker automatisk, og
              ingen lejer nogensinde modtager en ugyldig påkravsskrivelse fordi et felt manglede.
            </p>
            <p>
              Vi åbnede for de første brugere med digital kontraktoprettelse og MitID-signering.
              Huslejeopkrævning og bogføring er næste fase. Vi bygger det rigtigt — ikke hurtigt.
            </p>
          </div>
          <div className="mt-10 pt-8 border-t border-navy-200">
            <p className="text-navy-500 text-sm font-medium">Grundlægger</p>
            <p className="text-navy-950 font-semibold mt-1">Tobias Madsen</p>
            <p className="text-navy-600 text-sm">Dansk iværksætter og udlejer. Bygger det system han selv manglede.</p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-navy-950 text-center mb-12">Hvad vi tror på</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {values.map(({ title, desc }) => (
              <div key={title} className="bg-cream rounded-2xl p-8 border border-navy-100">
                <h3 className="text-navy-950 font-bold text-lg mb-3">{title}</h3>
                <p className="text-navy-600 leading-relaxed text-sm">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact + CTA */}
      <section className="bg-navy-950 py-20 px-6 text-white text-center">
        <div className="max-w-xl mx-auto">
          <h2 className="text-3xl font-bold mb-5">Skriv til os</h2>
          <p className="text-navy-300 mb-3 leading-relaxed">
            Har du spørgsmål, feedback eller ønsker du at blive tidlig bruger?
            Vi er altid interesserede i at tale med udlejere.
          </p>
          <a
            href="mailto:hej@boligflow.dk"
            className="text-white underline underline-offset-4 text-lg font-medium hover:text-navy-200 transition-colors"
          >
            hej@boligflow.dk
          </a>
          <div className="mt-10">
            <NavLink
              to="/features"
              className="bg-white text-navy-950 font-semibold px-8 py-3 rounded-lg hover:bg-cream transition-colors inline-flex items-center gap-2"
            >
              Se hvad vi bygger <ChevronRight size={18} />
            </NavLink>
          </div>
        </div>
      </section>
    </>
  )
}
